import { render, staticRenderFns } from "./textTitle4.vue?vue&type=template&id=0b19ff40&scoped=true"
import script from "./textTitle4.vue?vue&type=script&lang=js"
export * from "./textTitle4.vue?vue&type=script&lang=js"
import style0 from "./textTitle4.vue?vue&type=style&index=0&id=0b19ff40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b19ff40",
  null
  
)

export default component.exports